/** Minimal cookie helpers — just enough for a persisted, non-sensitive preference. */

const MAX_AGE_ONE_YEAR = 60 * 60 * 24 * 365

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null

  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))

  return match ? decodeURIComponent(match.slice(name.length + 1)) : null
}

export function setCookie(name: string, value: string, maxAgeSeconds = MAX_AGE_ONE_YEAR): void {
  if (typeof document === 'undefined') return

  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; samesite=lax`
}
